import { Component } from '@angular/core'
import { appConfig } from '../../../../brands/_current/config/app-config'
import { LoginService } from '../../../login/shared/login.service'

@Component({
  selector: 'app-inactive-account-page',
  templateUrl: './inactive-account-page.component.html',
  styleUrls: ['./inactive-account-page.component.scss'],
})
export class InactiveAccountPageComponent {
  public helplineNumber: string

  constructor(private readonly loginService: LoginService) {
    this.helplineNumber = appConfig.core.helplineNumber
  }

  onBackToLoginPageButton() {
    this.loginService.backToLogin().subscribe()
  }
}
